import { render } from "./proposals.vue?vue&type=template&id=71b000a5&scoped=true"
import script from "./proposals.vue?vue&type=script&lang=js"
export * from "./proposals.vue?vue&type=script&lang=js"

import "./proposals.vue?vue&type=style&index=0&id=71b000a5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b000a5"]])

export default __exports__